import React from 'react';
import { Box } from '~ui-kit/components/box/box';

interface PageContentContainerProps {
  children: React.ReactNode;
}

export function PageContentContainer({ children }: PageContentContainerProps) {
  return (
    <Box flexDirection="column" alignItems="center" py={[5, 6, 7]} px={[3]} flex="1 1 auto">
      <Box flexDirection="column" width={['100%', '100%', '100%', '970px']}>
        {children}
      </Box>
    </Box>
  );
}
